<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ct" id="toc_marker-5"><a href="#/Poisoned_Ground2#Contents-A">Acknowledgments</a></p>
<p class="fp">As always, I owe my thanks to many people who made the writing and publication of this book possible:</p>
<p class="Indent para-style-override-3">My husband, Jerry Parshall, and my friends Carol Baier and Cathrine Dubie for reading and critiquing the manuscript;</p>
<p class="Indent para-style-override-3"><span>My editor, Barbara Peters, for her perspective and guidance;</span></p>
<p class="Indent para-style-override-3">Jessica Tribble, Nan Beams, Suzan Baroni, and the rest of the crew at Poisoned Pen Press;</p>
<p class="Indent para-style-override-3">My friends in Sisters in Crime and Mystery Writers of America, who freely share their expertise in many professional fields and on a staggering range of topics;</p>
<p class="Indent para-style-override-3">And, most of all, my readers, whose notes of appreciation and encouragement make me believe the effort is worthwhile.</p>
<p class="body"></p>
<p class="body"></p>
<p class="body"></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Poisoned_Ground-4.vue?278f8705